import { ModuleModel } from '../../module.model.interface';

export class SecGroupDescriptor implements ModuleModel {
  public discriminator = 'SecGroupDescriptor';

  public id: string;
  public name: string;
  public description: string;

  public href: string;
  public modified: Date;
  public deleted: Date;

  constructor(options?: {
    id: string;
    name: string;
    description: string;

    href: string;
    modified: Date;
    deleted: Date;
  }) {

    if (options) {
      this.id = options.id;
      this.name = options.name;
      this.description = options.description;
      this.href = options.href;
      this.modified = options.modified;
      this.deleted = options.deleted;
    }

  }
}



// WEBPACK FOOTER //
// ./src/app/modules/secgroup/model/secgroup.ts